<template>

  <div id="delete-dialog" class="ui tiny modal delete-modal">

    <div class="ui header">
      Exclusão de Orçamento
    </div>

    <div class="content">

      <p>Confirma exclusão do Orçamento <strong>{{ quotation ? quotation.id : '' }}</strong> ?</p>

      <div class="ui orange message">
        <i class="exclamation circle icon"></i> Essa operação é irreversível
      </div> 

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui basic red button"  @click="onDelete()">
        <i class="times icon"></i>
        Excluir
      </button>      
    </div>

  </div>

</template>

<script>

  export default {

    props: ["quotation"],  

    beforeDestroy() {
      $(".delete-modal").remove()
    },
    
    methods: {

      show() {
        $("#delete-dialog").modal("show")        
      },

      hide() {
        $("#delete-dialog").modal("hide")
      },

      async onDelete() {

        this.$emit("onDelete")

        this.hide()
      },
    },
  }

</script>

